<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>邮件列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-table border :data="email_list">
          <el-table-column prop="from_name" label="寄件人" align="center"></el-table-column>
          <el-table-column prop="from" label="寄件人邮箱" align="center"></el-table-column>
          <el-table-column prop="to" label="收件人邮箱" align="center"></el-table-column>
          <el-table-column prop="subject" label="标题" align="center"></el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">{{ scope.row && scope.row.type === 2 ? '网页' : '文本' }}</template>
          </el-table-column>
          <el-table-column prop="status_str" label="状态" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <el-button type="text" icon="el-icon-edit" @click="seeContent(scope.row)">查看</el-button>

              <el-button
                v-if="scope.row.is_del == 0"
                class="success"
                type="text"
                @click="setStatus(scope.row.id)"
                icon="el-icon-setting"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import JSEncrypt from 'jsencrypt'

export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 15,
      email_list: []
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getEmails();
    },
    setStatus(id) {
      let _id = id;
      this.$confirm("是否删除当前邮件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          url: "/email/box/delete",
          data:{
            id: _id,
          },
          type:"POST",
        }).then(res => {
          loading.close()
          this.$util.msg(res.msg, "success");
          setTimeout(() => {
            this.getEmails();
          }, 1200);
        });
      })
      .catch(() => {});
    },
    seeContent(email) {
      this.$alert('<div style="width:100%;min-width: 600px; height: 500px; overflow: auto;">' + email.content + '</div>', '邮件内容', {
          dangerouslyUseHTMLString: true,
      }).then(() => {
        this.$ajax({
          url: '/email/box/ops',
          data: {
            id: email.id,
          },
          type:'POST'
        }).then(() => {})
      });
    },
    getEmails() {
      this.$ajax({
        url: "/email/box/index",
        data:{
          page: this.page,
          limit: this.pageSize
        }
      }).then(data => {
        this.email_list = data.data.data;
        this.total = data.data.total;
      });
    },
  },
  mounted() {
    this.getEmails();
  },
};
</script>
<style>
</style>